<template>
    <div>
        <b-form-group
            label="JS Personalizzato"
            label-for="custom-js">
            <ace-editor
                id="custom-js"
                style="height: 200px"
                @init="htmlEditorInit"
                lang="html"
                :value="settings['custom_js']"
                @input="setSetting('custom_js', $event)"></ace-editor>
        </b-form-group>
        <b-form-group
            label="CSS Personalizzato"
            label-for="custom-css">
            <ace-editor
                id="custom-css"
                style="height: 200px"
                @init="cssEditorInit"
                lang="css"
                :value="settings['custom_css']"
                @input="setSetting('custom_css', $event)"></ace-editor>
        </b-form-group>
        <b-form-group
            label="URL Logout"
            label-for="custom-logout-url">
            <b-form-input id="custom-logout-url" :value="settings['logout_url']" @input="setSetting('logout_url', $event)"></b-form-input>
        </b-form-group>
    </div>
</template>

<script>
export default {
    name: "AdvancedTab",
    props: {
        value: Object
    },
    computed: {
        settings() {
            if (!this.value.settings) {
                return {}
            }

            return JSON.parse(this.value.settings)
        },
    },
    methods: {
        setSetting(key, value) {
            let settings = this.settings
            settings = {
                ...settings,
                [key]: value,
            }

            let newValue = this.value;
            newValue.settings = JSON.stringify(settings)

            this.$emit('input', newValue);
        },
        htmlEditorInit(editor) {
            require('ace-builds/src-min-noconflict/ext-language_tools')
            require('ace-builds/src-min-noconflict/mode-html')
            require('ace-builds/src-min-noconflict/theme-ambiance')
            require('ace-builds/src-min-noconflict/snippets/html')
            require('ace-builds/src-min-noconflict/snippets/javascript')
            editor.session.setMode("ace/mode/html")
            editor.setOptions({
                enableBasicAutocompletion: true,
                enableSnippets: true,
                enableLiveAutocompletion: true
            });
        },
        cssEditorInit(editor) {
            require('ace-builds/src-min-noconflict/ext-language_tools')
            require('ace-builds/src-min-noconflict/mode-css')
            require('ace-builds/src-min-noconflict/theme-ambiance')
            editor.session.setMode("ace/mode/css")
            editor.setOptions({
                enableBasicAutocompletion: true,
                enableSnippets: true,
                enableLiveAutocompletion: true
            });
        }
    }
}
</script>

<style scoped>

</style>
